import { BASE_URL, LOCAL_AUTH_KEY } from '~/constants';

const token = () => {
  const auth = localStorage.getItem(LOCAL_AUTH_KEY);
  const json = JSON.parse(auth || '{}');

  return json.token;
};

export const xhrServerless = async (url: string, data?: { method?: string; body?: unknown }) => {
  try {
    if (token()) {
      url = `${url}&admin=true`;
    }
    const request = await fetch(url, {
      method: data?.method,
      body: JSON.stringify(data?.body),
    });

    if (!request.ok) {
      throw new Error(request.statusText);
    }

    return await request.json();
  } catch (error) {
    throw new Error('Serverless network error in xhr');
  }
};

export const xhr = async (url: string, data?: { method?: string; body?: unknown }) => {
  let headers;

  if (data?.method !== 'GET') {
    headers = {
      Authorization: `Bearer ${token()}`,
      'Content-Type': 'application/json',
    };
  }

  try {
    const request = await fetch(`${BASE_URL}${url}`, {
      method: data?.method,
      headers,
      body: JSON.stringify(data?.body),
    });

    if (!request.ok) {
      throw new Error(request.statusText);
    }

    return await request.json();
  } catch (error) {
    throw new Error('Network error in xhr');
  }
};
